import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const fakeCustomers = [{
  name: 'Andrés M.',
  city: 'Bogotá'
}, {
  name: 'Lucía P.',
  city: 'CDMX'
}, {
  name: 'Diego R.',
  city: 'Lima'
}, {
  name: 'Camila F.',
  city: 'Buenos Aires'
}, {
  name: 'Sebastián L.',
  city: 'Medellín'
}, {
  name: 'Isabella T.',
  city: 'Santiago'
}, {
  name: 'Mateo G.',
  city: 'Guadalajara'
}, {
  name: 'Sofía V.',
  city: 'Quito'
}, {
  name: 'Nicolás H.',
  city: 'Monterrey'
}, {
  name: 'Mariana C.',
  city: 'Caracas'
}, {
  name: 'Tomás A.',
  city: 'San José'
}, {
  name: 'Daniela S.',
  city: 'Panamá'
}, {
  name: 'Alejandro B.',
  city: 'Santo Domingo'
}, {
  name: 'Paula R.',
  city: 'Cali'
}, {
  name: 'Gabriel O.',
  city: 'Puebla'
}, {
  name: 'Fernanda D.',
  city: 'Córdoba'
}, {
  name: 'Joaquín E.',
  city: 'Guayaquil'
}, {
  name: 'Renata N.',
  city: 'Tegucigalpa'
}];
export function RecentPurchasePopup({
  enabled = true
}: {
  enabled?: boolean;
}) {
  const [visible, setVisible] = useState(false);
  const [customer, setCustomer] = useState(fakeCustomers[0]);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  const showNext = useCallback(() => {
    const randomCustomer = fakeCustomers[Math.floor(Math.random() * fakeCustomers.length)];
    const randomMinutes = Math.floor(Math.random() * 12) + 1;
    setCustomer(randomCustomer);
    setMinutesAgo(randomMinutes);
    setVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  }, []);
  useEffect(() => {
    if (dismissed || !enabled) return;
    // Show first popup after 10 seconds
    const initialTimeout = setTimeout(() => {
      showNext();
    }, 10000);
    // Then every 45 seconds
    const interval = setInterval(() => {
      showNext();
    }, 45000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [dismissed, showNext, enabled]);
  if (dismissed) return null;
  return <div className="fixed bottom-4 left-4 right-4 z-50" style={{
    maxWidth: '320px'
  }} data-id="element-290">
      <AnimatePresence data-id="element-291">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="bg-[#1a1a1a] border border-gray-700/50 rounded-xl p-4 shadow-2xl shadow-black/50" data-id="element-292">
            <button onClick={() => setDismissed(true)} className="absolute top-2 right-2 text-gray-600 hover:text-gray-400 transition-colors" aria-label="Cerrar" data-id="element-293">
              <X size={14} data-id="element-294" />
            </button>

            <div className="flex items-start gap-3" data-id="element-295">
              {/* Icon */}
              <div className="w-10 h-10 bg-brand-yellow/10 rounded-lg flex items-center justify-center shrink-0" data-id="element-296">
                <ShoppingBag size={18} className="text-brand-yellow" data-id="element-297" />
              </div>

              {/* Content */}
              <div className="min-w-0" data-id="element-298">
                <p className="text-white text-sm font-medium leading-tight" data-id="element-299">
                  {customer.name}{' '}
                  <span className="text-gray-400 font-normal" data-id="element-300">compró</span>
                </p>
                <p className="text-green-400 text-xs font-bold mt-0.5" data-id="element-301">
                  El Mapa 3×3 — $7.89 USD
                </p>
                <p className="text-gray-500 text-[11px] mt-1.5" data-id="element-302">
                  {customer.city} · hace {minutesAgo}{' '}
                  {minutesAgo === 1 ? 'minuto' : 'minutos'}
                </p>
              </div>
            </div>

            {/* Subtle progress bar that shows how long the popup stays */}
            <motion.div className="absolute bottom-0 left-0 h-[2px] bg-brand-yellow/30 rounded-b-xl" initial={{
          width: '100%'
        }} animate={{
          width: '0%'
        }} transition={{
          duration: 5,
          ease: 'linear'
        }} data-id="element-303" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}